var CartFreeGift = class extends HTMLElement {
  connectedCallback() {
    this.freeGiftProduct = this.dataset.freeGiftProduct;
    this.minCartTotal = parseFloat(this.dataset.minCartTotal) || 35;
    this.freeGiftMessage = this.dataset.freeGiftMessage || 'Free gift with purchase';
    this.freeGiftVariantCount = this.dataset.freeGiftVariantCount;
    this.quickBuyModal = this.querySelector('quick-buy-modal');
    this.quickBuyModal.addEventListener('dialog:force-close', () => this.dismissFreeGift());

    // Check for dismissal cookie on load
    this.checkDismissalCookie();
    
    // Initialize free gift functionality
    this.init();
  }

  init() {
    // Check eligibility on load
    this.checkFreeGiftEligibility();
    
    // Listen for cart updates
    document.addEventListener('cart:change', () => this.checkFreeGiftEligibility());
    
    // Listen for cart drawer open
    document.addEventListener('cart-drawer:opened', () => this.checkFreeGiftEligibility());
  }

  checkDismissalCookie() {
    const cookies = document.cookie.split(';');
    const dismissedCookie = cookies.find(cookie => 
        cookie.trim().startsWith('free_gift_dismissed=')
    );
    
    if (dismissedCookie && dismissedCookie.includes('true')) {
        this.hasDismissed = true;
    } else {
        this.hasDismissed = false;
    }
  }

  dismissFreeGift() {
    // Set cookie to expire in 7 days
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + 7);
    
    document.cookie = `free_gift_dismissed=true; expires=${expirationDate.toUTCString()}; path=/`;
    
    this.hasDismissed = true;
  }

  async checkFreeGiftEligibility() {

    if (this.hasDismissed) {
      return
    }

    try {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      // Calculate cart total (excluding free gift)
      const cartTotal = this.calculateCartTotal(cart);
      
      // Convert threshold to customer's currency if needed
      const thresholdInCustomerCurrency = this.getThresholdInCustomerCurrency();
      const isEligible = cartTotal >= thresholdInCustomerCurrency;
      const hasFreeGift = this.hasFreeGiftInCart(cart);
      
      if (isEligible && !hasFreeGift) {
        if (this.freeGiftVariantCount > 1) {
          this.quickBuyModal.show();
        } else {
          await this.addFreeGiftSilently();
        }
      } else if (!isEligible && hasFreeGift) {
        // Remove free gift if no longer eligible
        await this.removeFreeGiftSilently();
      }
      
      // Hide component completely
      this.style.display = 'none';
      
    } catch (error) {
      console.error('Error checking free gift eligibility:', error);
    }
  }

  getThresholdInCustomerCurrency() {
    // Check if Shopify Currency is available and customer is not using default currency
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active !== window.Shopify.currency.rate) {
      const currentRate = parseFloat(window.Shopify.currency.rate);
      const thresholdInUSD = this.minCartTotal; // Base threshold is in USD
      
      // Convert threshold to customer's currency
      const thresholdInCustomerCurrency = thresholdInUSD * currentRate;
      
      return thresholdInCustomerCurrency;
    }
    
    return this.minCartTotal;
  }

  calculateCartTotal(cart) {
    return cart.items
      .filter(item => !this.isFreeGiftProduct(item))
      .reduce((total, item) => total + (item.final_price * item.quantity), 0) / 100;
  }

  isFreeGiftProduct(item) {
    return item.product_id.toString() === this.freeGiftProduct || 
           item.handle === this.freeGiftProduct ||
           item.variant_id.toString() === this.freeGiftProduct;
  }

  hasFreeGiftInCart(cart) {
    return cart.items.some(item => this.isFreeGiftProduct(item));
  }

  async addFreeGiftSilently() {
    try {
      const formData = new FormData();
      formData.append('id', this.freeGiftProduct);
      formData.append('quantity', 1);
      formData.append('properties[_free_gift]', 'true');

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });

      if (response.ok) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true // Prestige theme, refresh the cart
        }));
      } else {
        throw new Error('Failed to add free gift');
      }

    } catch (error) {
      console.error('Error adding free gift silently:', error);
    }
  }

  async removeFreeGiftSilently() {
    try {
      
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      const freeGiftItem = cart.items.find(item => this.isFreeGiftProduct(item));
      
      if (freeGiftItem) {
        const formData = new FormData();
        formData.append('id', freeGiftItem.variant_id);
        formData.append('quantity', 0);

        await fetch('/cart/change.js', {
          method: 'POST',
          body: formData
        });

        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true // Prestige theme, refresh the cart
        }));
      }
    } catch (error) {
      console.error('Error removing free gift silently:', error);
    }
  }
}

if (!window.customElements.get("cart-free-gift")) {
  window.customElements.define("cart-free-gift", CartFreeGift);
}